import { Helmet } from 'react-helmet-async';
import { SITE_URL, BUSINESS } from './businessConfig';

/**
 * Per-page SEO head tags. Falls back to business defaults.
 */
function SeoHead({
  title,
  description,
  keywords,
  path = '/',
  type = 'website',
  image = `${SITE_URL}/og-image.jpg`,
  noindex = false,
  jsonLd,
}) {
  const canonical = `${SITE_URL}${path === '/' ? '' : path}`;
  const fullTitle = title || `${BUSINESS.brandName} | Agroturystyka Strzyżów`;

  return (
    <Helmet>
      <html lang="pl" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content={noindex ? 'noindex,nofollow' : 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1'} />
      <link rel="canonical" href={canonical} />

      {/* Geo / local */}
      <meta name="geo.region" content="PL-PK" />
      <meta name="geo.placename" content="Brzeżanka, Strzyżów" />
      <meta name="geo.position" content={`${BUSINESS.geo.latitude};${BUSINESS.geo.longitude}`} />
      <meta name="ICBM" content={`${BUSINESS.geo.latitude}, ${BUSINESS.geo.longitude}`} />

      {/* Open Graph */}
      <meta property="og:locale" content="pl_PL" />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={BUSINESS.brandName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={`${BUSINESS.brandName} — basen i teren agroturystyki w Brzeżance`} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Business contact for knowledge panels */}
      <meta property="business:contact_data:street_address" content={BUSINESS.address.streetAddress} />
      <meta property="business:contact_data:locality" content={BUSINESS.address.addressLocality} />
      <meta property="business:contact_data:region" content={BUSINESS.address.addressRegion} />
      <meta property="business:contact_data:postal_code" content={BUSINESS.address.postalCode} />
      <meta property="business:contact_data:country_name" content="Poland" />
      <meta property="business:contact_data:phone_number" content={BUSINESS.telephoneDisplay} />
      <meta property="business:contact_data:email" content={BUSINESS.email} />
      <meta property="place:location:latitude" content={String(BUSINESS.geo.latitude)} />
      <meta property="place:location:longitude" content={String(BUSINESS.geo.longitude)} />

      {jsonLd
        ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((schema, i) => (
            <script key={i} type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          ))
        : null}
    </Helmet>
  );
}

export default SeoHead;
